import script from "./ArtistList.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtistList.vue?vue&type=script&setup=true&lang=js"

import "./ArtistList.vue?vue&type=style&index=0&id=49dd665a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49dd665a"]])

export default __exports__